import { initializeDrift } from 'client/javascript/drift';
import { trackInteraction } from './analytics';

let didStartPlaybook = false;

export function handleClickChatUs(interactionId) {
  document.getElementById('live-chat').addEventListener('click', () => {
    if (!window.drift) {
      initializeDrift();
    }

    global.drift.on('ready', api => {
      if (!didStartPlaybook) {
        global.drift.api.startInteraction({ interactionId });
        didStartPlaybook = true;
      } else {
        api.sidebar.open();
      }
    });
  });
}

export function initNavTrackingListeners() {
  const navLinks = document.getElementsByClassName('track-nav-link-click');
  for (let i = 0; i < navLinks.length; i++) {
    const linkEl = navLinks[i];
    linkEl.addEventListener('click', () => {
      trackInteraction({ label: 'Nav - Main links', toPath: linkEl.pathname });
    });
  }
}
